import React from 'react';
import { GroupedProjects } from '../../components/common/GroupedProjects';

export function AllProjects() {
  return <GroupedProjects pageTitle="All Projects" />;
}

export default AllProjects;
